'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _jsxFileName = 'src/new-business/routes.js';
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _propTypes = require('prop-types');
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _reactRouterDom = require('react-router-dom');
var _paymentFailure = require('../payment-pages/payment-failure');
var _paymentFailure2 = _interopRequireDefault(_paymentFailure);
var _paymentSuccess = require('../payment-pages/payment-success');
var _paymentSuccess2 = _interopRequireDefault(_paymentSuccess);
var _auto = require('./auto');
var _constants = require('./constants');
var _noquote = require('./noquote');
var _noquote2 = _interopRequireDefault(_noquote);
var _quickQuote = require('./quick-quote');
var _quickQuote2 = _interopRequireDefault(_quickQuote);
var _stage = require('./stage1');
var _stage2 = _interopRequireDefault(_stage);
var _stage3 = require('./stage2');
var _stage4 = _interopRequireDefault(_stage3);
var _stage5 = require('./stage3');
var _stage6 = _interopRequireDefault(_stage5);
var _stage7 = require('./stage4');
var _stage8 = _interopRequireDefault(_stage7);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var NewBusiness = function (_Component) {
  _inherits(NewBusiness, _Component);
  function NewBusiness() {
    _classCallCheck(this, NewBusiness);
    return _possibleConstructorReturn(this, (NewBusiness.__proto__ || Object.getPrototypeOf(NewBusiness)).apply(this, arguments));
  }
  _createClass(NewBusiness, [{
    key: 'render',
    value: function render() {
      var _this2 = this;
      var _props = this.props,
        prefix = _props.prefix,
        container = _props.container;
      return _react2.default.createElement(_react.Fragment, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 30
        },
        __self: this
      }, _react2.default.createElement(_reactRouterDom.Route, {
        path: prefix + '/stage',
        __source: {
          fileName: _jsxFileName,
          lineNumber: 31
        },
        __self: this
      }, _react2.default.createElement(_auto.AutoFill, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 32
        },
        __self: this
      })), _react2.default.createElement(_reactRouterDom.Switch, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 34
        },
        __self: this
      }, _react2.default.createElement(_reactRouterDom.Route, {
        path: prefix + '/quick-quote',
        render: function render() {
          return _react2.default.createElement(_quickQuote2.default, {
            linkPrefix: '' + prefix,
            container: container,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 37
            },
            __self: _this2
          });
        },
        __source: {
          fileName: _jsxFileName,
          lineNumber: 35
        },
        __self: this
      }), _react2.default.createElement(_reactRouterDom.Route, {
        path: prefix + '/stage1',
        render: function render() {
          return _react2.default.createElement(_stage2.default, {
            linkPrefix: '' + prefix,
            container: container,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 41
            },
            __self: _this2
          });
        },
        __source: {
          fileName: _jsxFileName,
          lineNumber: 39
        },
        __self: this
      }), _react2.default.createElement(_reactRouterDom.Route, {
        path: prefix + '/stage2',
        render: function render() {
          return _react2.default.createElement(_stage4.default, {
            linkPrefix: '' + prefix,
            container: container,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 45
            },
            __self: _this2
          });
        },
        __source: {
          fileName: _jsxFileName,
          lineNumber: 43
        },
        __self: this
      }), _react2.default.createElement(_reactRouterDom.Route, {
        path: prefix + '/stage3',
        render: function render() {
          return _react2.default.createElement(_stage6.default, {
            linkPrefix: '' + prefix,
            container: container,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 49
            },
            __self: _this2
          });
        },
        __source: {
          fileName: _jsxFileName,
          lineNumber: 47
        },
        __self: this
      }), _react2.default.createElement(_reactRouterDom.Route, {
        path: prefix + '/stage4',
        render: function render() {
          return _react2.default.createElement(_stage8.default, {
            linkPrefix: '' + prefix,
            container: container,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 53
            },
            __self: _this2
          });
        },
        __source: {
          fileName: _jsxFileName,
          lineNumber: 51
        },
        __self: this
      }), _react2.default.createElement(_reactRouterDom.Route, {
        path: prefix + '/noquote',
        render: function render() {
          return _react2.default.createElement(_noquote2.default, {
            container: container,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 57
            },
            __self: _this2
          });
        },
        __source: {
          fileName: _jsxFileName,
          lineNumber: 55
        },
        __self: this
      }), _react2.default.createElement(_reactRouterDom.Route, {
        path: prefix + '/payment-success',
        render: function render() {
          return _react2.default.createElement(_paymentSuccess2.default, {
            failureLink: prefix + '/payment-failure',
            stages: _constants.stages,
            type: 'NEW',
            container: container,
            sku: 'LDI',
            __source: {
              fileName: _jsxFileName,
              lineNumber: 62
            },
            __self: _this2
          });
        },
        __source: {
          fileName: _jsxFileName,
          lineNumber: 59
        },
        __self: this
      }), _react2.default.createElement(_reactRouterDom.Route, {
        path: prefix + '/payment-failure',
        render: function render() {
          return _react2.default.createElement(_paymentFailure2.default, {
            tryAgainLink: prefix + '/stage4',
            container: container,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 73
            },
            __self: _this2
          });
        },
        __source: {
          fileName: _jsxFileName,
          lineNumber: 71
        },
        __self: this
      }), _react2.default.createElement(_reactRouterDom.Redirect, {
        to: prefix + '/stage1',
        __source: {
          fileName: _jsxFileName,
          lineNumber: 75
        },
        __self: this
      })));
    }
  }]);
  return NewBusiness;
}(_react.Component);
NewBusiness.propTypes = {
  prefix: _propTypes.string,
  container: _propTypes.bool
};
NewBusiness.defaultProps = {
  prefix: '/ldi/new',
  broker: false,
  container: true
};
exports.default = NewBusiness;